import React, { useState, useEffect } from 'react'

interface ModalBaseProps {
    isOpen: boolean
    onClose: () => void
    children: React.ReactNode
}

export const ModalBase: React.FC<ModalBaseProps> = ({ isOpen, onClose, children }) => {
    const [show, setShow] = useState(isOpen)

    useEffect(() => {
        if (isOpen) setShow(true)
        else setTimeout(() => setShow(false), 300)
    }, [isOpen])

    if (!show) return null

    return (
        <div
            className={`fixed inset-0 z-[100] flex items-end md:items-center justify-center pointer-events-none ${isOpen ? 'opacity-100' : 'opacity-0'
                } transition-opacity duration-300`}
        >
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-sm pointer-events-auto"
                onClick={onClose}
            />
            <div
                className={`w-full md:w-[420px] md:rounded-lg bg-surface-light dark:bg-surface-card rounded-t-[2rem] shadow-[0_-8px_30px_rgba(0,0,0,0.12)] pointer-events-auto flex flex-col overflow-hidden transform transition-transform duration-300 ${isOpen ? 'translate-y-0' : 'translate-y-full md:translate-y-10 md:opacity-0'
                    }`}
                style={{ maxHeight: '90vh' }}
            >
                {/* Drag Handle (Mobile) */}
                <div className="flex flex-col items-center pt-3 pb-2 w-full md:hidden">
                    <div className="h-1.5 w-12 rounded-full bg-gray-300 dark:bg-white/20" />
                </div>

                {/* Content */}
                <div className="relative flex-1 overflow-y-auto no-scrollbar px-6 pb-8 pt-2">
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-6 p-1 rounded-full text-gray-500 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
                    >
                        <span className="material-symbols-outlined font-light">close</span>
                    </button>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default ModalBase
